<template>
    <div class="Office" v-if="lang">
        <md-whiteframe class="shadow shadow-faint">
            <div class="search search--field">
                <div class="icon">
                    <!-- <md-icon>search</md-icon> -->
                    <br>
                </div>
                <div class="input">
                    <!-- <input type="text" v-model="search.query" :placeholder="translate.pages.office.index.search" style="outline:0;" data-step="4" data-intro="Escribe el nombre de la Consulta, se realizara automaticamente"> -->
                    <!-- <span class="status">{{ searchIndicator }}</span> -->
                </div>
                <md-button data-step="1" data-intro="Presiona el Boton para Solicitar un Box" class="md-icon-button md-raised button" @click.native="openDialog('edit', 'new')">
                    <md-icon>add</md-icon>
                </md-button>
                <!-- <md-button v-else class="md-icon-button md-raised button-remove" @click.native="removeOffices">
                    <md-icon>clear</md-icon>
                </md-button> -->
            </div>
        </md-whiteframe>
        <div class="table table--office table-mobile has-status table--queries">
            <md-table-card  class="table--wrap">
                <div v-if="disabledRegion">
                    <div class="sk-rotating-plane"></div>
                </div>
                <div v-else>
                    <md-table md-sort="name" @sort="onSort"  @select="onSelect">
                        <md-table-header>
                            <md-table-row>
                                <md-table-head class="td-sort-name center-mobile" md-sort-by="yt">Especialidad</md-table-head>
                                <md-table-head class="hidden-mobile" md-sort-by="street">{{translate.pages.office.index.fields.address}}</md-table-head>
                                <md-table-head class="hidden-mobile">Precio</md-table-head>
                                <md-table-head md-sort-by="active" class="text-center hidden-mobile">{{translate.pages.office.index.fields.status}}</md-table-head>
                                <md-table-head class="text-center hidden-mobile">{{translate.pages.office.index.fields.actions}}</md-table-head>
                            </md-table-row>
                        </md-table-header>
                        <md-table-body v-if="offices.length > 0">
                            <md-table-row v-for="(row, rowIndex) in offices" :key="rowIndex" :md-item="row" >
                                <md-table-cell class="name--cell">
                                    <span class="name">{{ row.speciality.name }}</span>
                                    <span class="subname visible-mobile">{{ row.region.toponymName }}, {{row.city.toponymName}}</span>
                                    <span class="subname visible-mobile">
                                       <strong>
                                            ${{ row.price }}
                                        </strong>
                                    </span>
                                </md-table-cell>
                                <md-table-cell class="hidden-mobile">
                                    <span class="hidden-mobile">{{ row.region.toponymName }}, {{row.city.toponymName}}</span>
                                </md-table-cell>
                                <md-table-cell class="hidden-small">
                                    <span>
                                        <strong>
                                            ${{ row.price }}
                                        </strong>
                                    </span>
                                </md-table-cell>
                                <md-table-cell class="static-mobile">
                                    <div class="enabled" :class="{ 'active' : row.active }">{{ row.active | formatEnabled }}</div>
                                </md-table-cell>
                                <md-table-cell class="actions">
                                     <!-- <md-icon class="icon-edit raised"  @click.native="openDialog('tasks', row, rowIndex)">attach_money</md-icon> -->
                                     <span>
                                        <md-icon class="icon-edit raised" data-step="2" data-intro="Presiona el Boton  Editar" @click.native="openDialog('edit', row, rowIndex)">edit</md-icon>
                                        <md-tooltip>Editar</md-tooltip>
                                     </span>
                                    <span>
                                        <md-icon :class="row.active === true ? 'icon-delete raised' : 'icon-success raised'" data-step="3" data-intro="Presiona el Boton de Eliminar" @click.native="statud(row, rowIndex)">{{ row.active === true ? 'do_disturb_alt' : 'check_box'}}</md-icon>
                                        <md-tooltip>{{ row.active === true ? 'Desactivar' : 'Activar'}}</md-tooltip>
                                    </span>
                                     <span>
                                        <md-icon class="icon-history raised" data-step="2" data-intro="Presiona el Boton  Editar" @click.native="openHistory('history', row, rowIndex)">history</md-icon>
                                        <md-tooltip>Historial</md-tooltip>
                                     </span>
                                </md-table-cell>
                            </md-table-row>
                        </md-table-body>
                    </md-table>
                </div>
            </md-table-card>
            <div class="pagination" v-if="offices.length > 0">
                <a class="pagination-item double-arrow" href="javascript:;" v-on:click="filterTable('prev_all')">
                <md-icon>keyboard_arrow_left</md-icon>
                <md-icon>keyboard_arrow_left</md-icon>
                </a>
                <a class="pagination-item" href="javascript:;" v-on:click="filterTable('prev_page')">
                <md-icon>keyboard_arrow_left</md-icon>
                </a>
                <div class="pagination-info">
                <b>{{ datatable.filters.pages.current_page }}</b> de
                <b>{{ datatable.filters.pages.last_page }}</b>
                </div>
                <a class="pagination-item" href="javascript:;" :style="`pointer-events:${datatable.pointer}`" v-on:click="filterTable('next_page')">
                <md-icon>keyboard_arrow_right</md-icon>
                </a>
                <a class="pagination-item double-arrow" href="javascript:;" v-on:click="filterTable('next_all')">
                <md-icon>keyboard_arrow_right</md-icon>
                <md-icon>keyboard_arrow_right</md-icon>
                </a>
            </div>
            <!-- <jw-pagination v-if="offices.length > 0" :items="offices" @changePage="onChangePage" :labels="customLabels" :styles="customStyles"></jw-pagination> -->

            <div v-if="offices.length === 0" >
                <h3 class="not-found mini-found" v-if="search.isQuery">{{translate.pages.office.index.no_name_result}} "<strong>{{ search.query }}".</strong></h3>
                <h3 v-else>
                    <span class="not-found mini-found" v-if="fetchData">Aún no ha agregado Solicitudes de BOX.</span>
                    <span v-else>
                        <div class="sk-rotating-plane"></div>
                    </span>
                </h3>
            </div>
        </div>
        <md-dialog md-open-from="#custom" md-close-to="#custom" ref="edit"
            :md-click-outside-to-close="close"
            :md-esc-to-close="close">
            <md-dialog-content>

                <add-box @closed="closed" :boxData="boxObj" :infoData="infoObj"></add-box>

            </md-dialog-content>
        </md-dialog>
        <md-dialog md-open-from="#custom" md-close-to="#custom" ref="history" >
            <md-dialog-content>

                <view-history @closed="closed" :historyArray="historyArray"  v-if="dialogHistory"></view-history>

            </md-dialog-content>
        </md-dialog>
        <md-dialog md-open-from="#custom" md-close-to="#custom" ref="helper"
            :md-click-outside-to-close="close"
            :md-esc-to-close="close">
            <md-dialog-content>
                <h3 class="dialog--title">Tutor Interactivo</h3>
                <hr>
                <div class="content-main">
                    <md-layout md-gutter class="modal-wrap">
                    Seleccione un proceso:<br>
                    <md-button class="md-raised md-primary" style="width:100%" @click.native="launchTutor(1)">Crear Una Consulta</md-button>
                    <md-button :disabled="offices.length ==0" class="md-raised md-primary" style="width:100%" @click.native="launchTutor(2)">Editar Una Consulta</md-button>
                    <md-button :disabled="offices.length ==0" class="md-raised md-primary" style="width:100%" @click.native="launchTutor(3)">Eliminar Una Consulta</md-button>
                    </md-layout>
                </div>
            </md-dialog-content>
            <md-dialog-actions class="modal--footer">
                <md-button style="padding: 0 15px;" class="float-l md-primary sm-size md-size" @click.native="closeHelper">{{translate.pages.office.edit.cancel}}</md-button>
            </md-dialog-actions>
        </md-dialog>
        <div style="height:40px;display:block;width:100%"></div>
    </div>
</template>
<script>
    import AddBox from './EditBoxDoctor'
    import ViewHistory from './history'
    const swal = require('sweetalert2');
    import { doctor, public_api } from '../../../config/api.js';
    import axios from 'axios';
    import vueSelect from "vue-select";
    var tour = introJs()
    export default {
        components: {vueSelect, AddBox, ViewHistory},
        data: () => ({
            dialogHistory: false,
            historyArray: null,
            boxObj: null,
            boxes: [],
            regions: [],
            comunities: [],
            specialities: [],
            offices: [],
            disabledRegion: true,
            datatable: {
                filters: {
                    pages: {
                        last_page: null,
                        current_page: null,
                        first_page: null,
                        next_page_url: '',
                        prev_page_url: ''
                    }
                },
                pointer_next: ''
            },
            infoObj: null,
            doctor : {
                code : '',
                name : '',
                lastname : '',
                lastname2 : '',
                email : '',
                phone : '',
                password : '',
                password_confirmation : '',
                notification_appointment : false,
                notification_mail : false,
                notification_sms : false,
                type: 'doctor',
                specialities: [],
                region: {label:'',value:''},
                city: {label:'',value:''},
                bon_particular: 1,
                bon_fonasa: 1,
                bon_isapre: 1
            },
            fetchData: false,
            close: false,
            page: {},
            search: {
                query: '',
                queryIsDirty: false,
                isCalculating: false,
                isQuery: false
            },
            process: false,
        }),
        computed: {
            // Search indicator
            searchIndicator: function () {
                if (this.search.isCalculating) {
                    return '⟳'
                } else if (this.search.queryIsDirty) {
                    return '...'
                } else {
                    return '✓'
                }
            },
            // Get path office
            path() {
                if(!this.currentOffice.path){
                    return 'https://api.agendaenlinea.cl/image/default_avatar.png';
                }
                return this.currentOffice.path;
            },
            // Get Language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get Lang
            lang(){
                return this.$store.getters.language.lang;
            },
            // Get User
            user(){
                return this.$store.getters.user;
            }
        },
        created() {
            self = this;
            // Get Offices
            this.$http.get('/boxes/requests',{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data;
                    this.datatable.filters.pages = {
                        last_page: data.last_page,
                        current_page: data.current_page,
                        first_page: 1,
                        next_page_url: data.next_page_url,
                        prev_page_url: data.prev_page_url,
                        total: data.total
                    }
                    // storage comunities
                    this.offices = data.data;
                    this.boxes = data;
                    this.fetchData = true;
                    this.disabledRegion = false
                }).catch(error => {
                    if(!error.response)
                    {
                        if(error.request.status == 0)
                        {
                            this.$router.push({'name':'logout'});
                        }
                    }
                });
            // if(!this.$store.getters.language.app){
            //     this.loadLanguage();
            // }else{
                this.getSpecialities();
            // }
            var country = { "country": this.$route.params.country.toUpperCase() };
            this.$http.post(public_api.api.regions, country).then(response => {
                    let data = response.data.data;
                    data.map((item, index) => {
                        item.value = item.geonameId;
                        item.label = item.toponymName;
                    });
                    // storage regions
                    this.regions = data;
                    //console.log(this.regions)
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
        },
        methods: {
            statud(row, rowIndex) {
                let id = row.id
                let status = null
                if(row.active === true)
                {
                    status = 'Desactivara'
                } 
                else {
                    status = 'Activar'
                }
                swal(
                    status+' la Solicitud del box', 
                    "", 
                    'warning'
                )
                .then( () => {
                this.$http.patch('/boxes/requests/'+id+'/toggle', {}, {
                    headers: {
                        Authorization: "Bearer " + this.$auth.getToken()
                    },
                }).then(response => {
                    row.active = !row.active
                })
                })
            },
            filterTable(params) {
                console.log(params)
                let n = null
                if(this.datatable.filters.pages.next_page_url && params === 'next_page') {
                    n = this.datatable.filters.pages.current_page + 1
                    console.log('next', n)
                }
                if(this.datatable.filters.pages.prev_page_url && params === 'prev_page')
                {
                    n = this.datatable.filters.pages.current_page - 1
                    console.log('prov', n)
                }
                if(params === 'next_all' && this.datatable.filters.pages.next_page_url) {
                    n = this.datatable.filters.pages.last_page
                    console.log('next_all', n)
                }
                if(params === 'prev_all' && this.datatable.filters.pages.prev_page_url) {
                    n = 1
                    console.log('prev_all', n)
                }
                    console.log(n)
                if(n) {
                    this.$http.get('/boxes/requests?page='+n, {
                        headers: {
                            Authorization: "Bearer " + this.$auth.getToken()
                        },
                    }).then(response => {
                        let data = response.data;
                        this.datatable.filters.pages = {
                            last_page: data.last_page,
                            current_page: data.current_page,
                            first_page: 1,
                            next_page_url: data.next_page_url,
                            prev_page_url: data.prev_page_url,
                            total: data.total
                        }
                        this.offices = data.data;
                     })
                }
            },
            onChangePage(pageOfItems) {
                 this.$http.get("https://api.agendaenlinea.cl/api/boxes/requests?page=2")
            },
            launchTutor(step){
                this.closeHelper()
                tour.setOption('tooltipPosition', 'bottom');

                tour.setOption('showButtons', false);
                tour.setOption('showStepNumbers', false);
                tour.setOption('showProgress', false);
                tour.setOption('showBullets', false);
                tour.start();
                if(step){
                    tour.goToStep(step);
                }
            },
            closed(data) {
                
                this.$refs['edit'].close();
                this.$refs['history'].close();
                this.historyArray = null
                this.dialogHistory = false

                if (data) {
                    const item = this.offices.find(item => item.id === data.id)

                    item ? Object.assign(item, data) : this.offices.push(data.data)
                }
                this.$http.get('/boxes/requests',{
                    headers: {
                        Authorization : 'Bearer '+ this.$auth.getToken(),
                    }
                    }).then(response => {
                        let data = response.data;
                        this.datatable.filters.pages = {
                            last_page: data.last_page,
                            current_page: data.current_page,
                            first_page: 1,
                            next_page_url: data.next_page_url,
                            prev_page_url: data.prev_page_url,
                            total: data.total
                        }
                        // storage comunities
                        this.offices = data.data;
                        this.boxes = data.data;
                        this.fetchData = true;
                        this.disabledRegion = false
                    }).catch(error => {
                        if(!error.response)
                        {
                            if(error.request.status == 0)
                            {
                                this.$router.push({'name':'logout'});
                            }
                        }
                    })
            },
            getProvinciaRegion(){
                if (this.$route.params.country == 'cl')
                    this.provincia_region = 'Región';
                else
                    this.provincia_region = 'Provincia';
            },

            getSpecialities(){
                let url = doctor.speciality.list + '?country=cl' + '&lang=es'
                this.$http.get(url)
                    .then(response => {
                        if(response.data.status == "OK"){
                            let data = response.data.data;
                            data.map((item, index) => {
                                item.value = item.id;
                                item.label = item.name;
                                item.medicine_type = item.medicine_type;
                        
                            });

                         
                            this.specialities = data;
                        }
                    }).catch(error => {
                        console.error("error de espes");
                        console.log(error);
                    });
            },

            // Open Modal
            openDialog(ref, row, rowIndex) {
                if(row === 'new')
                {
                    this.boxObj = this.form
                    this.infoObj = this.infoObj
                }
                else {
                    let periodo = null
                    if(row.period === 'monthly_full')
                    {
                        periodo = 'Mensual: AM y PM'
                    } else {
                        periodo = 'Mensual: 1/2 día AM o PM'
                    }
                    this.infoObj = {
                        special  : row.speciality.name,
                        region      : row.region.toponymName,
                        city        : row.city.toponymName,
                        period      : periodo,
                    }
                    this.boxObj = Object.assign({}, row)
                }

                console.log(Object.assign({}, row))
                console.log('row', row)
                this.currentCopy = Object.assign({}, row);
                this.$refs[ref].open();
            },
            openHistory(ref, row, rowIndex){
                this.historyArray = Object.assign({}, row)
                this.$refs[ref].open();
                this.dialogHistory = true
                // swal('En Construcción', "Esta sección se encuentra en intenso desarrollo.", 'warning')
            },
            // Open helper
            openHelper() {
                let ref = "helper";
                this.$refs[ref].open();
            },
            // Close helper
            closeHelper() {
                let ref = "helper";
                this.$refs[ref].close();
                console.log("blabal")
            },

            // Close Modal
            addTask(data){
                let final_data = {
                    office_id: this.currentOffice.id,
                    task_id: this.addTaskData.bonus_task.id,
                    fonasa_price: parseInt(this.addTaskData.bonus_task.previsions[0].pivot.final_price) * parseInt(this.addTaskData.copago_amplifier),
                    particular_price:  parseInt(this.addTaskData.task_particular_price)
                }
                this.$http.post("/doctor/addTask", final_data, {
                            headers: {
                                Authorization : 'Bearer '+ this.$auth.getToken(),
                            }
                    }).then(response => {
                        console.log("new task", response.data.data);
                        this.addTaskData.task_code = "";
                        this.addTaskData.bonus_task = false;
                        this.currentOffice.tasks.push(response.data.data);
                        this.$refs["addTask"].close();

                    })
            },

            searchTask(){
                this.addTaskData.bonus_task = false;
                let type = "bonus_task_doctor";
                let data = {type: type}
                let query = this.addTaskData.task_code;
                data.column = 'code'
                data.query = query
                data.is_doctor = true;
                if(!data.query || data.query.length <= 6){
                    return;
                }
                this.$http.post("/patient/search", data, {
                    headers: {
                    Authorization: 'Bearer ' + this.$auth.getToken()
                    }
                }).then(response => {
                    let data = response.data.data
                    console.log(data)
                    if(data.length == 1){
                    this.addTaskData.bonus_task = data[0]
                    this.addTaskData.task_particular_price = parseInt(this.addTaskData.bonus_task.previsions[0].pivot.price);
                    } else {
                        this.addTaskData.bonus_task = false;
                    }

                }).catch(error => {
                    this.addTaskData.bonus_task = false;
                    console.log(error)
                // alert("No se pudo cargar las comunidades")
                })
            },
            // Show button add
            onSelect(data) {
                this.selectedData = data;
                this.$forceUpdate();
                (_.size(this.selectedData) >= 1) ? this.addButton = false : this.addButton = true;
            },
            // Sort offices
            onSort(sort) {
                this.offices = _.orderBy(this.offices, [item => item[sort.name]], sort.type);
            },
            // Paginate
            onPagination(page) {
                this.page = page;
            },
            // Remove office
            remove(row, rowIndex){
                swal(this.translate.pages.office.index.swal.remove.title, this.translate.pages.office.index.swal.remove.message, 'warning')
                    .then( () => {
                        this.$http.delete(doctor.api.offices + '/' + row.id,{
                                    headers: {
                                        Authorization : 'Bearer '+ this.$auth.getToken(),
                                    }
                            }).then(response => {
                                let data = response.data.data;
                                swal('', response.data.msg, 'success')
                                    .then( () => {
                                        this.offices.splice(rowIndex, 1);
                                    }, (dismiss) => {
                                        this.offices.splice(rowIndex, 1);
                                    });
                            }).catch(error => {
                                console.log(error);
                            });
                    }, (dismiss) => {
                        //console.log(dismiss);
                    });
            },

            // Method to search
            expensiveOperation: _.debounce( function() {
                this.search.isCalculating = true;
                let data = {'query': this.search.query, 'type': 'offices'};
                this.$http.post(doctor.api.search, data, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    this.offices = data;
                    this.search.isCalculating = false;
                    this.search.queryIsDirty = false;
                    this.search.isQuery = true;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
            }, 500),

             changeRegion(value){
                if(value){
                    let region = this.regions.find(item => {
                        return item.geonameId == value.geonameId})
                    if(region){
                        this.data.region.label = region.label
                        this.data.region.value = region.value
                        this.$http.post(public_api.api.cities, {region: this.data.region.value})
                            .then(response => {
                                let data = response.data.data
                                data.map(item => {
                                    item.value = item.geonameId
                                    item.label = item.toponymName
                                })
                                this.comunities = data
                                this.data.city.label = ''
                                this.data.city.value = ''
                            })
                    }
                }else{
                    this.comunities = []
                }
            },
            // Change City
            changeCity(value) {
                if(value){
                    if(typeof value != 'string'){
                        let city = this.comunities.find(item => {
                            return item.geonameId == value.geonameId})
                        this.data.city.label = city.label
                        this.data.city.value = city.value
                    }
                }else{
                    this.data.city.label = ''
                    this.data.city.value = ''
                }
            },
        },
        watch: {
            'search.query': function () {
                this.search.queryIsDirty = true;
                this.expensiveOperation();
            },
            'addTaskData.task_code' : function(val) {
                if(val && val.length && val.length >=7){
                    this.searchTask();
                }
            },
            'lang': function(val) {
                if(val){
                    // this.getSpeciliaties(true);
                }
            }
        }
    }
</script>
<style lang="stylus" scoped>
    @import '../../../assets/styles/variables/color.styl'
    @import '../../../assets/styles/loading.styl'
    .pagination
        display inline-block
        margin-top 12px
        font-size 16px
        color #959a9e
        .pagination-info
            display inline-block
            position relative
            top -18px
            padding 0 8px
        .pagination-item
            display inline-block
            width 42px
            height 42px
            border 1px solid color_form_border
            line-height 40px
            text-align center
            padding 0	
            border-radius 4px
            margin 3px
            color #959a9e
            text-decoration none
            position relative
            overflow hidden
            transition all 0.3s ease-out
            &:hover
                color #FFF
                background-color color_main
                border-color color_main
            i
                width auto
                height auto
                display inline-block
                min-width 0
                margin 0
            &.double-arrow
                i
                    position absolute
                    left 4px
                    top 7px
                i + i
                    left 10px
        b
            color color_main !important
    .Office
        .search
            display flex
            padding 1em
            .icon
                text-align center
                width 50px
            .input
                width 100%
                input
                    border 0
                    height 2em
                    width 100%
            .button
                background-color color_main
                color white
                position absolute
                right 1em
                top 2.45em
                &:hover
                    background-color color_main
                    color white
            .button-remove
                background-color color_error
                color white
                position absolute
                right 1em
                top 2.45em
                &:hover
                    background-color color_error
                    color white
            .status
                color color_form_placeholder
                font-size 1.5em
                left 0.35em
                position absolute
                top 0.75em
        .table
            padding 3em 2em 2em 2em
            .img
                -webkit-border-radius 50%
                -moz-border-radius 50%
                border-radius 50%
                position relative
                width 45px
                height 45px
                float left
                overflow hidden
                background transparent
                img
                    width auto
                    min-height 100%
                    min-width 100%
                    height auto
                    left 0
            .name
                margin-left 12px
                position relative
                top 12px
            .text-center
                text-align center
            .icon-edit
                color color_notifications
                cursor pointer
                font-size 22px
            .icon-delete
                color color_error
                cursor pointer
                font-size 22px
            .enabled
                border 1px solid color_form_placeholder
                border-radius 30px
                color color_form_placeholder
                margin 0 auto
                padding 3px 4px
                text-align center
                width 110px
                &.active
                    border 1px solid color_confirm
                    color color_confirm
    .content-main
        .container
            padding 0.25em 1em
            .picture
                position relative
                .icon
                    background-color color_main
                    border 3px solid white
                    border-radius 50%
                    bottom -1em
                    cursor pointer
                    height 40px
                    padding 8px
                    position absolute
                    right -1em
                    width 40px
                    text-align center
                    i
                        color white
                        position relative
                        left -3px
                        top -3px
            .multiple
                border 1px solid color_form_border
                border-radius 5px
                width 100%
                .title
                    margin 0.5em
                    color color_form_placeholder
                    &.error
                        border-color color_error !important
                        color rgba(0, 0, 0, .87) !important
                .select
                    overflow-y scroll
                    overflow-x hidden
                    margin 0.25em
                    height 110px
                    .option
                        width 95%
                        margin 0.25em
            .subtitle
                margin-top .5em
                color color_form_placeholder
    .mini_cover_image
        width 45px
        height 45px
        display block
        background-size cover
        background-position center
    @media (max-width: 768px)
        .mini_cover_image
            width 50px
            height 50px
    @import '../../../assets/styles/responsive.styl'
</style>
<style>
        .icon-view {
        color: #fac31d;
    }
    @media (max-width: 460px){
        .icon-view {
        color: #fac31d;
        margin-top: -20px !important;
        font-size: 30px !important;
        margin-right: -6px !important;
    }
    }
    .md-theme-default 
    .md-dialog-container 
    .md-dialog {
        width: 100% !important;
    }
    .icon-success{
        color: green;
        cursor: pointer;
        font-size: 22px;
    }
    .icon-history {
        color: #39b7c0;
        cursor: pointer;
        font-size: 22px;
    }
.raised{
    cursor: pointer !important;
}
.icon-edit{
    color: green;
}
.icon-delete{
    color: red;
}
button.add_task_btn:disabled {
    background: #d9f3f6 !important;
}
.pseudo_table {
        display: block;
    background: #f0f0f0;
    height: 60px;
    border: #bdb6b63d inset 0.5px;
    border-collapse: collapse;
    padding: 10px;
    text-align: center;
    line-height: 40px;
}

.pseudo_table.w50 {
    width: 50%;
}

ul.task_list {
    width: 100%;
}

.pseudo_table.w25 {
    width: 25%;
}
.pseudo_table.w50.is_name {
white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 60px;
  height: auto !important;
  line-height: 18px;
  font-size: 13px;
}
.is_name .data-mobile {
  display: none;
}

li.md-list-item.table_header b {
    font-size: 13px !important;
}



@media(max-width: 735px){

.pseudo_table.w50.is_name {
white-space: normal !important;
}
.is_name .data-mobile {
  display: block !important;
}
li.md-list-item.table_header {
    display: none;
}

.pseudo_table.w50.is_name {
    max-height: 200px;
    height: auto;
}

.pseudo_table.w25.is_data {
    display: none;
}

.pseudo_table.w50.is_name {
    width: 100%;
}
}

.delete_presta {
    float: left;
    cursor: pointer;
    color: #e84f4f !important;
}
</style>



// WEBPACK FOOTER //
// Index.vue?3803fe12